import { ReactNode, useState } from 'react';
import { Button } from '@treezor/design-system';

interface IAddLayout {
  shouldShow: boolean;
  label: string;
  children: ReactNode;
}

export function AdditonalDataLayout({ shouldShow = false, label, children }: IAddLayout) {
  const [isShown, setShow] = useState<boolean>(shouldShow);

  return (
    <>
      {isShown ? (
        children
      ) : (
        <div>
          <Button variant="ghost" icon="add_circle" size="s" onClick={() => setShow(true)}>
            {label}
          </Button>
        </div>
      )}
    </>
  );
}
